/* @flow */
import React from "react";

import { Link } from "../common/Link";
import Gettext from "../common/Gettext";
import { Row, Input, SelectColor, SelectWidth } from "../Popup";
import { InfoBlock } from "./ToolsContent";
import { COLORS } from "../Popup/SelectColor";
import { WIDTHS } from "../Popup/SelectWidth";

export const initialState = {
  accelerationFactor: 0.02,
  accelerationStep: 0.02,
  accelerationMaxValue: 0.2,
  color: COLORS[0],
  size: WIDTHS[1]
};

export const indicatorTitle = <Gettext>Parabolic SAR</Gettext>;

export const Info = <InfoBlock>
  <Gettext>
    Parabolic SAR is similar to Moving Average but moves with higher boost and can change its position corresponding to the current price. <Link to="/helpdesk/knowledge_base#kb_i">
      <Gettext>Learn more about the indicator.</Gettext>
    </Link>
  </Gettext>
</InfoBlock>;

type Props = {
  indicator: Object,
  activeSelect: String,
  handleClick: Function,
  handleChange: Function,
  handleNumberChange: Function
};

const ParabolicSARPopup = (props: Props) => (
  <Row>
    <Input
      label={<Gettext>Step</Gettext>}
      name="accelerationStep"
      value={props.indicator.accelerationStep}
      onChange={props.handleAsIsChange}
      invalid={props.errors && props.errors.accelerationStep}
    />
    <Input
      label={<Gettext>Maximum step</Gettext>}
      name="accelerationMaxValue"
      value={props.indicator.accelerationMaxValue}
      onChange={props.handleAsIsChange}
      invalid={props.errors && props.errors.accelerationMaxValue}
    />
    <SelectColor
      label={<Gettext>Colour</Gettext>}
      name="color"
      value={props.indicator.color}
      activeSelect={props.activeSelect}
      onClick={props.handleClick}
      onChange={props.handleAsIsChange}
    />
    <SelectWidth
      label={<Gettext>Point size</Gettext>}
      name="size"
      value={props.indicator.size}
      activeSelect={props.activeSelect}
      onClick={props.handleClick}
      onChange={props.handleAsIsChange}
    />
  </Row>
);

export default ParabolicSARPopup;



// WEBPACK FOOTER //
// ./src/components/Toolbar/ParabolicSARPopup.js